import React, { useState } from "react";
import ReactDom from "react-dom";
import App from "../../App";
import Splash from "../Splash";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { postData } from "../../components/helpers/Data";
import Modal2 from "../../components/helpers/Modal2";
import { currentYear } from "../../components/helpers/today";
import NewPassword from "./NewPassword";
import UpdatePassword from "./UpdatePassword";

export const Login = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [feedback, setFeedback] = useState([]);

  const loginUser = (e) => {
    e.preventDefault();
    const formData = new FormData(document.getElementById("login_form"));
    postData(formData, "login_user")
      .then((data) => {
        
        // return console.log(data.user.length);
        if (data.length != 0) {
          if (data.pass_count <= 5) {
            ReactDOM.render(<NewPassword />, document.getElementById("root"));
          } else {
            saveDataInStorage(data);
          }
        } else {
          setFeedback(["Sorry, password or username is incorrect!"]);
          setModalIsOpen(true);
        }
      })
      .catch((error) => console.log(error));
  };

  const saveDataInStorage = (data) => {
    if (typeof Storage !== "undefined") {
      sessionStorage.setItem("mwerezi_mpos_username", data.user[0].user_name);
      sessionStorage.setItem("mwerezi_mpos_first_name", data.user[0].first_name);
      sessionStorage.setItem("mwerezi_mpos_last_name", data.user[0].last_name);
      sessionStorage.setItem("mwerezi_mpos_surname", data.user[0].surname);
      sessionStorage.setItem("mwerezi_mpos_usergroups", JSON.stringify(data.user_group));
      checkIfPasswordExpired();
    } else {
      setFeedback(["Sorry, something went wrong, please contact admin"]);
    }
  };

  const checkIfPasswordExpired = () => {
    const frmData = new FormData();
    frmData.append("user_name", sessionStorage.getItem("mwerezi_mpos_username"));
    postData(frmData, "check_last_password_change")
      .then((data) => {
        // return console.log(data);
        if (data[0] >= 30) {
          ReactDom.render(
            <BrowserRouter>
              <UpdatePassword />
            </BrowserRouter>,
            document.getElementById("root")
          );
        } else {
          // ReactDom.render(
          //   <BrowserRouter>
          //     <App />
          //   </BrowserRouter>,
          //   document.getElementById("root")
          // );
          ReactDom.render(
            <BrowserRouter>
              <Splash />
            </BrowserRouter>,
            document.getElementById("root")
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div>
      <a className="hiddenanchor" id="signin"></a>

      <div className="login_wrapper">
        <div className="animate form login_form">
          {/* <section className="login_content"> */}
          <section className="text-center">
            <form id="login_form" onSubmit={loginUser}>
              <h1>
                <span className="display-5 text-success font-weight-bold">
                  MPOS
                </span>
              </h1>
              <div className="mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  required={true}
                  name="user_name"
                />
              </div>
              <div>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  required={true}
                  name="password"
                />

                <p style={{ color: "red" }}></p>
              </div>
              <div>
                <button type="submit" className="btn btn-info form-control">
                  Log in
                </button>
              </div>

              <div className="clearfix"></div>
              <div>
                <p>© {currentYear()} All Rights Reserved.</p>
              </div>
              <div className="separator"></div>
            </form>
          </section>
        </div>
      </div>
      <Modal2
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        body={
          <span className="h4 text-white font-weight-bold text-center">
            {feedback}
          </span>
        }
        background={
          feedback.length > 0
            ? feedback[0].includes("Sorry")
              ? "#d9534f"
              : "#105878"
            : ""
        }
      />
    </div>
  );
};

export default Login;
